import { z } from 'zod';

export const CustomPresetsSchema = z.object({
  daslCustomPresetsPath: z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value) {
          return true; // Optional: Allow empty values, or change to false if required.
        }

        // TODO: Update this to use API validation for Databricks paths (https://app.shortcut.com/antimatter/story/7134/field-api-validation)
        const pathRegex = /^\/Volumes\/[a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+\//;
        return pathRegex.test(value);
      },
      {
        message: 'Path must be in format /Volumes/<catalog>/<schema>/',
      },
    ),
  daslStoragePath: z.string(),
});

export type CustomPresetsSchemaValues = z.infer<typeof CustomPresetsSchema>;
